import { render } from "./d3table.vue?vue&type=template&id=253ac5cb&scoped=true"
import script from "./d3table.vue?vue&type=script&lang=js"
export * from "./d3table.vue?vue&type=script&lang=js"

import "./d3table.vue?vue&type=style&index=0&id=253ac5cb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253ac5cb"]])

export default __exports__